import { contactConfig } from '../config/contact';
export function createWhatsAppUrl(message: string): string { return `https://wa.me/${contactConfig.whatsappNumber}?text=${encodeURIComponent(message)}`; }
